export const LOAD_ROUTES_PROCESS = 'LOAD_ROUTES_PROCESS';
export const LOAD_SECTIONS_PROCESS = 'LOAD_SECTIONS_PROCESS';
export const LOAD_DEPOTS_PROCESS = 'LOAD_DEPOTS_PROCESS';
export const LOAD_ROUTE_DETAILS_PROCESS = 'LOAD_ROUTE_DETAILS_PROCESS';
export const LOAD_SAVE_PROCESS = 'LOAD_SAVE_PROCESS';
export const RESET_CHANGES_PROCESS = 'RESET_CHANGES_PROCESS';
export const LOAD_VALIDATE_ROUTE_CODE_PROCESS =
  'LOAD_VALIDATE_ROUTE_CODE_PROCESS';
export const CHANGE_PASSWORD_PROCESS = 'CHANGE_PASSWORD_PROCESS';
export const SUBMIT_DRIVER_PROCESS = 'SUBMIT_DRIVER_PROCESS';
export const ACCEPT_DRIVER_REQUEST_PROCESS = 'ACCEPT_DRIVER_REQUEST_PROCESS';
export const CONFIRM_DRIVER_REQUEST_PROCESS = 'CONFIRM_DRIVER_REQUEST_PROCESS';
export const REJECT_DRIVER_REQUEST_PROCESS = 'REJECT_DRIVER_REQUEST_PROCESS';
export const RECOVERY_ACCESS_PROCESS = 'RECOVERY_ACCESS_PROCESS';
export const RESYNC_ROUTE_PROCESS = 'RESYNC_ROUTE_PROCESS';
export const CHECK_CHOICE_ROUTE = 'CHECK_CHOICE_ROUTE';
export const RECONSOLIDATION_PROCESS = 'RECONSOLIDATION_PROCESS';
